/* istanbul ignore next */
import {
  MY_GEM_VAULT_ROUTE,
  PAYMENTS_ROUTE,
  CONTACT_US_ROUTE,
  GEM_GPT_ROUTE,
  USERS_ROUTE,
  SETTINGS_ROUTE,
  POROLIS_GEM_BANK_ROUTE,
  MY_GEM_FAV_ROUTE,
  MANAGE_SUBSCRIPTION,
  SUBORDINATES_ROUTE,
  MY_PROFILE_ROUTE,
  INVITATIONS_ROUTE,
} from './routes';

export enum Titles {
  GemGPT = 'GemGPT™',
  Users = 'Users',
  MyGemFav = 'MyGemFav',
  MyGemVault = 'MyGemVault',
  ManageSubscription = 'Manage Subscription',
  ContactUs = 'Contact Us',
  Payments = 'Payments',
  Settings = 'Settings',
  GemBank = 'Gem Bank',
  Subordinates = 'Subordinates',
  MyProfile = 'My Profile',
  ForgotPassword = 'Forgot Password',
  SignUp = 'Sign Up',
  Login = 'Login',
}

export const getTitle = (firstPathPart: string) => {
  switch (firstPathPart) {
    case MY_GEM_VAULT_ROUTE:
      return Titles.MyGemVault;
    case PAYMENTS_ROUTE:
      return Titles.Payments;
    case CONTACT_US_ROUTE:
      return Titles.ContactUs;
    case GEM_GPT_ROUTE:
      return Titles.GemGPT;
    case USERS_ROUTE:
      return Titles.Users;
    case SUBORDINATES_ROUTE:
      return Titles.Subordinates;
    case INVITATIONS_ROUTE:
      return Titles.Subordinates;
    case MY_PROFILE_ROUTE:
      return Titles.MyProfile;
    case SETTINGS_ROUTE:
      return Titles.Settings;
    case POROLIS_GEM_BANK_ROUTE:
      return Titles.GemBank;
    case MY_GEM_FAV_ROUTE:
      return Titles.MyGemFav;
    case MANAGE_SUBSCRIPTION:
      return Titles.ManageSubscription;
    default:
      return '';
  }
};

export const mapTitleToBeDisplayed = (pathname?: Titles) => {
  switch (pathname) {
    case Titles.Users:
      return 'Admin (Customer) - Global List';
    case Titles.Payments:
      return 'Invoice - Payment Status';
    case Titles.Settings:
      return 'Settings';
    case Titles.GemBank:
      return 'Porolis GemBANK™';
    case Titles.ForgotPassword:
      return 'Forgot Password';
    case Titles.SignUp:
      return 'Sign Up';
    case Titles.Login:
      return 'Login';
    case Titles.GemGPT:
      return 'GemGPT';
    case Titles.MyGemVault:
      return 'myGemVAULT™';
    case Titles.MyGemFav:
      return 'myGemFAV™';
    case Titles.Subordinates:
      return 'Subordinates';
    case Titles.MyProfile:
      return 'My Profile';
    case Titles.ManageSubscription:
      return 'Manage Subscription';
    default:
      return '';
  }
};
